import { ICell } from '~/ui/components/reusable/EditTableModal/types';

export const cells: { [key: string]: ICell } = [
  {
    id: 'maxNotificationLevel',
    label: 'Level',
    useSort: true,
    align: 'center',
  },
  {
    id: 'fullName',
    label: 'Name',
    useSort: true,
  },
  {
    id: 'subjectId',
    label: 'Patient ID',
    useSort: true,
  },
  {
    id: 'programName',
    label: 'Program Name',
    useSort: true,
  },
  {
    id: 'latestReadingMeasuredAt',
    label: 'Latest Reading',
    useSort: true,
    align: 'center',
  },
  {
    id: 'activityMinutesCount',
    label: 'Activity Minutes',
    useSort: true,
    align: 'center',
  },
  {
    id: 'uniqueDaysCount',
    label: 'Unique Days',
    useSort: true,
    align: 'center',
  },
  {
    id: 'totalReadingsCount',
    label: 'Total Readings',
    useSort: true,
    align: 'center',
  },
  {
    id: 'isHomeHealthCare',
    label: 'Home Health Care',
    useSort: true,
    align: 'center',
  },
  {
    id: 'status',
    label: 'Status',
    useSort: true,
  },
  {
    id: 'hasTelephoneConversation',
    label: 'Telephone Conversation',
    useSort: true,
    align: 'center',
  },
  {
    id: 'bloodPressureAverage',
    label: 'BP Average',
    useSort: false,
    align: 'center',
  },
  {
    id: 'latestNoteCreatedAt',
    label: 'Latest Note',
    useSort: true,
    align: 'center',
  },
].reduce((result, x) => ({ ...result, [x.id]: x }), {});

export default {};
